import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Typography } from 'antd';
import React from 'react';
import './OfferContent.scss';

const OfferContent = (props) => {
  const {form, onFinish, closeModal} = props;
  return (
    <div className='offer-content'>
      <Row>
        <Form form={form} onFinish={onFinish}>
          <Row gutter={[12, 8]}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Mã chương trình</Typography.Text>}
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{
                  span: 16
                }}
                name='maChuongTrinh'
              >
                <Input
                  className="data-input-field"
                  placeholder="Nhập"
                  size='large'
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Tên chương trình</Typography.Text>}
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{
                  span: 16
                }}
                name='tenChuongTrinh'
              >
                <Input
                  className="data-picker-field"
                  placeholder="Nhập"
                  size='large'
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Ngày tạo</Typography.Text>}
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{
                  span: 16
                }}
                name='ngayTao'
              >
                <DatePicker
                  className="data-picker-field"
                  placeholder="DD/MM/YYYY"
                  size='large'
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Người tạo</Typography.Text>}
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{
                  span: 16
                }}
                name='nguoiTao'
              >
                <Input
                  className="data-input-field"
                  placeholder="Nhập"
                  size='large'
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Áp dụng từ</Typography.Text>}
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{
                  span: 16
                }}
                name='apDungTu'
              >
                <Select
                  className="data-select-field"
                  placeholder="Chọn"
                  size='large'
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Giá thành</Typography.Text>}
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{
                  span: 16
                }}
                name='giaThanh'
              >
                <Input
                  className="data-input-field"
                  placeholder="NHập"
                  size='large'
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Giá giảm %</Typography.Text>}
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{
                  span: 16
                }}
                name='giaGiam'
              >
                <Input
                  className="data-input-field"
                  placeholder="Nhập"
                  size='large'
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Mô tả</Typography.Text>}
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{
                  span: 16
                }}
                name='moTa'
              >
                <Input
                  className="data-input-field"
                  placeholder="Nhập"
                  size='large'
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                label={<Typography.Text ellipsis>ĐK áp dụng khuyến mãi</Typography.Text>}
                labelAlign="left"
                labelCol={{span: 4}}
                wrapperCol={{
                  span: 20
                }}
                name='giaGiam'
              >
                <Input
                  className="data-input-field"
                  placeholder="Nhập"
                  size='large'
                />
              </Form.Item>
            </Col>
          </Row>
          <Row justify={'end'}>
            <Space className="modal-footer">
              <Button type='primary' onClick={closeModal} danger>
                Hủy
              </Button>
              <Button type="primary" onClick={closeModal} htmlType='submit'>
                Xác nhận
              </Button>
            </Space>
          </Row>
        </Form>
      </Row>
    </div>
  );
};

export default OfferContent;